import { tv } from 'tailwind-variants';

export const CardStyle = tv({
  base: 'group relative overflow-hidden rounded-lg h-96 cursor-pointer',
});

export const BackgroundImage = tv({
  base: 'absolute inset-0 h-full w-full object-cover',
});

export const CardContent = tv({
  base: 'flex flex-col relative bg-[linear-gradient(180deg,rgba(4,_30,_73,_0.00)_35.94%,#041E49_85.8%)] h-full',
});

export const Band = tv({
  base: 'w-full inline-flex gap-sm py-1 px-4',
  variants: {
    color: {
      red: 'bg-feedback-color-error-pure text-card-color-default',
      yellow: 'bg-feedback-color-warning-pure text-card-color-negative',
      green: 'bg-feedback-color-success-pure text-card-color-default',
      default: 'bg-brand-color-primary-pure text-card-color-default',
    },
  },
});
